import * as React from 'react';
import toast from 'cogo-toast';
import dayjs from 'dayjs';
import { Page, Card, Icon } from 'tabler-react';
import { Link } from 'react-router-dom';
import PageComponent from '../PageComponent';
import If from '../../components/if';
import Request from '../../shared/request';
import './vas.scss';
import store from '../../shared/store';
import i18n from '../../shared/i18n';

const PAY_METHODS = {
  WECHAT: {
    icon: 'ri-wechat-fill',
    name: i18n.t('buy-type-wechat'),
  },
  ALIPAY: {
    icon: 'ri-alipay-fill',
    name: i18n.t('buy-type-alipay'),
  },
  PAYPAL: {
    icon: 'ri-paypal-fill',
    name: 'Paypal',
  },
  FOMO_WECHAT: {
    icon: 'ri-wechat-fill',
    name: '微信',
  },
  FOMO_ALIPAY: {
    icon: 'ri-alipay-fill',
    name: '支付宝',
  },
  FOMO_PAYPAL: {
    icon: 'ri-paypal-fill',
    name: 'Paypal',
  },
  DEFAULT: {
    icon: 'ri-bank-card-fill',
    name: 'Pay'
  },
  STRIPE: {
    icon: 'ri-bank-card-fill',
    name: 'Stripe',
  },
};

const VasTips = (props) => {
  const { plan } = props
  if (!plan || store.user.planExpiredAt < Date.now()) {
    return ''
  }
  switch (plan.category) {
    case 'device':
      return (
        <div className="time-tips">
          <div>
            <div className="mb-time">
              <span>{i18n.t('dash-vas-planexpire')}</span>
              <span>{dayjs(store.user.planExpiredAt).format('YYYY.MM.DD')}</span>
            </div>
            {store.user.bandwidthExpiredAt ? (
              <div className="vas-time">
                <span>{i18n.t('dash-vas-expire')}</span>
                <span>
                  {store.user.extraClientsExpiredAt > Date.now()
                    ? dayjs(store.user.extraClientsExpiredAt).format('YYYY.MM.DD')
                    : i18n.t('dash-vas-expired')}
                </span>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      );
    case 'bandwidth':
      // eslint-disable-next-line no-case-declarations
      const vasPlanExpiredAt = plan.category === 'bandwidth' ? store.user.bandwidthExpiredAt : store.user.gameBandwidthExpiredAt
      return (
        <div className="time-tips">
          <div>
            <div className="mb-time">
              <span>{i18n.t('dash-vas-planexpire')}:</span>
              <span>{dayjs(store.user.planExpiredAt).format('YYYY.MM.DD')}</span>
            </div>
            {vasPlanExpiredAt ? (
              <div className="vas-time">
                <span>{i18n.t('dash-vas-expire')}:</span>
                <span>
                  {vasPlanExpiredAt > Date.now()
                    ? dayjs(vasPlanExpiredAt).format('YYYY.MM.DD')
                    : i18n.t('dash-vas-expired')}
                </span>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      );
    default:
      return ''
  }
}

class VasIndex extends PageComponent {
  state = {
    plans: [],
    promotions: [],
    promotion: null,
    plan: null,
    paymethod: '',
    loading: false,
    qrcodeBase64: '',
    planId: null,
    checking: false,
    days: 0,
  };

  async componentDidMount() {
    const {plans, promotions} = await Request.call('getVasPlans');
    this.setState({ plans, promotions });
    let planId;
    let plan = plans[0];
    try {
      const URLsearch = new URLSearchParams(window.location.search);
      planId = URLsearch.get('planId');
    } catch (error) {
      // noop
    }
    if (planId) {
      this.setState({ planId });
      const defaultPlan = plans.find(p => p.planId === planId);
      plan = defaultPlan || plan;
    }
    this.changePlan(plan);

  }

  changePlan = plan => {
    this.planDays = plan.days;
    this.setState({ plan, paymethod: plan.paidType[0], days: plan.days  });
    this.setDays({days: plan.days})
  };

  findPromotionByDays = (days) => {
    const promotion = this.state.promotions && this.state.promotions.find(v => {
      const { day: { $gte, $gt, $lt, $lte } } = v
      if ($gte && !(days >= $gte)) {
        return false
      }
      if ($lte && !(days <= $lte)) {
        return false
      }
      if ($gt && !(days > $gt)) {
        return false
      }
      if ($lt && !(days < $lt)) {
        return false
      }
      return true
    })
    return promotion
  };

  hasDiscount = (days) => {
    const promotion = this.findPromotionByDays(days)
    if (promotion) {
      return <div className="discount-tag">{Math.round((1-promotion.discount)*100)}% OFF</div>
    }
    return ''
  };

  setDays = ({days}) => {
    const promotion = this.findPromotionByDays(days)
    this.setState({ days, promotion });
  };

  changePayMethod = paymethod => {
    this.setState({ paymethod });
  };

  changeDay = () => {
    this.setState({ days: this.planDays });
  };

  daysClassName = days => {
    if (this.state.plan && this.state.plan.days <= 0) {
      return 'tag disable';
    }
    if (this.state.plan && days > this.state.plan.days) {
      return 'tag disable';
    }
    if (days === this.state.days) {
      return 'tag active';
    }
    return 'tag';
  };

  totalPrice = (originPrice = false) => {
    let {discount = 1} = this.state.promotion || {}
    if (originPrice) {
      discount = 1
    }
    if (!this.state.plan) {
      return '--'
    }
    const USD = (this.state.plan.dayPriceUSD * this.state.days * discount).toFixed(2)
    const CNY = Math.floor(this.state.plan.dayPrice * this.state.days * discount)
    const symbol = this.state.paymethod === 'PAYPAL' ? '$' : '¥'
    const price = this.state.paymethod === 'PAYPAL' ? USD : CNY
    if (Number.isNaN(price)) {
      return '--'
    }
    return `${symbol} ${price}`
  };

  discountPrice = () => {
    let {discount = 1} = this.state.promotion || {}
    discount = 1 - discount
    if (discount === 0) {
      return ''
    }
    if (this.state.paymethod === 'PAYPAL') {
      return `（ 已优惠$ ${this.state.plan
        ? (this.state.plan.dayPriceUSD * this.state.days * discount).toFixed(2)
        : '--'
        } ）`;
    }
    return `（ 已优惠¥ ${this.state.plan
      ? Math.floor(this.state.plan.dayPrice * this.state.days * discount)
      : '--'
      } ）`;
  }

  checkOrder = async () => {
    if (this.state.confirmInfo) {
      this.setState({ checking: true });

      const data = await Request.call('confirmPayment', {
        confirmInfo: this.state.confirmInfo,
        paidType: this.state.paymethod,
      });
      this.setState({ checking: false });
      if (data.status === 'PAID') {
        this.props.history.push('/dashboard');
        toast.success(i18n.t('dash-vas-paid'));
      }
    } else {
      toast.warn(i18n.t('dash-vas-paidalert'));
    }
  };

  // @deprecated change to fomo
  startPaypal = async () => {
    this.setState({ loading: true });
    const payInfo = await Request.call('createVasPaypalPayment', {
      planId: this.state.plan.planId,
      paidType: this.state.paymethod,
      days: this.state.days,
    });
    this.setState({ loading: false });
    if (payInfo.redirectUrl) {
      // window.location.href = payInfo.redirectUrl;
      window.open(payInfo.redirectUrl);
    }
  };

  startPay = async () => {
    // if (this.state.paymethod === 'PAYPAL') {
    //   this.startPaypal();
    //   return;
    // }
    this.setState({ loading: true });
    const data = await Request.call('createOrder', {
      category: 'vas',
      planId: this.state.plan.planId,
      paidType: this.state.paymethod,
      days: this.state.days,
    });
    this.setState({ loading: false });
    if (data.fomo && data.fomo.codeUrl) {
      this.setState({
        qrcodeBase64: data.fomo.codeUrl,
        confirmInfo: data.confirmInfo,
      });
    }
    if (data.fomo && data.fomo.redirectUrl) {
      window.open(data.fomo.redirectUrl);
    }
    if (data.redirectUrl) {
      window.open(data.redirectUrl);
    }
    // if (data.wechat && data.wechat.qrcodeUrl) {
    //   this.setState({
    //     qrcodeBase64: data.wechat.qrcodeUrl,
    //     confirmInfo: data.confirmInfo,
    //   });
    // }
    // if (data.alipay && data.alipay.redirectUrl) {
    //   window.open(data.alipay.redirectUrl);
    // }
  };

  render() {
    return (
      <Page.Content className="page-vas page-bind">
        <Card>
          <div
            className={`pay-qrcode ${this.state.qrcodeBase64 ? '' : 'hidden'}`}>
            <Card className="content">
              <Card.Header>
                <Card.Title>
                  {this.state.paymethod &&
                    PAY_METHODS[this.state.paymethod].name}
                  {i18n.t('dash-vas-pay')}
                </Card.Title>
                <div
                  className="closed"
                  onClick={() => this.setState({ qrcodeBase64: '' })}>
                  <Icon name="x" />
                </div>
              </Card.Header>
              <Card.Body>
                <div className="qrcode">
                  <img src={this.state.qrcodeBase64} alt="" />
                  <div className="tips">
                    <i className="ri-qr-scan-line" />
                    请使用
                    {this.state.paymethod &&
                      PAY_METHODS[this.state.paymethod].name}
                    扫码支付
                  </div>
                </div>
                <div className="right">
                  <span className="title">{i18n.t('dash-vas-total')}</span>
                  <div className="vas-price">{this.totalPrice()}</div>
                  <div className="tips">{i18n.t('dash-vas-ordertip')}</div>
                </div>
              </Card.Body>
              <div className="bottom">
                <div
                  className="btn-vas-close"
                  onClick={() => this.setState({ qrcodeBase64: '' })}>
                  {i18n.t('dash-vas-paycancel')}
                </div>
                <div
                  className={`btn-vas-check ${this.state.checking ? 'loading' : ''
                    }`}
                  onClick={() => this.checkOrder()}>
                  {this.state.checking ? i18n.t('dash-vas-checking') : i18n.t('dash-vas-checked')}
                </div>
              </div>
            </Card>
          </div>

          <Card.Header>
            <Link to="/dashboard">
              <i className="fa fa-angle-left" />
              <span>{i18n.t('dash-btn-back')}</span>
            </Link>
            <Card.Title>{i18n.t('dash-vas-buytitle')}</Card.Title>
          </Card.Header>
          <div className="content">
            <div className="product">
              {this.state.plan ? (
                <div className="thumb">
                  <img
                    src={this.state.plan && this.state.plan.cover}
                    alt={this.state.plan.title}
                  />
                </div>
              ) : (
                <div className="thumb loading-thumb" />
              )}

              <div className="des">
                <div className="name">
                  {this.state.plan ? this.state.plan.cateName : '...'}
                </div>

                <div className="vas-type">
                  <div className="label">{i18n.t('dash-vas-plantitle')}</div>

                  {this.state.planId ? (
                    <div className="choose-tag">
                      <div className="tag active">
                        {this.state.plan ? this.state.plan.title : '...'}
                      </div>
                    </div>
                  ) : (
                    <div className="choose-tag">
                      {this.state.plans &&
                        this.state.plans.map(plan => (
                          <div
                            onClick={() => this.changePlan(plan)}
                            className={`tag ${this.state.plan &&
                              plan.planId === this.state.plan.planId
                              ? 'active'
                              : ''
                              }`}>
                            {plan.title}
                          </div>
                        ))}
                    </div>
                  )}
                </div>

                <div className="vas-time">
                  <div className="label">{i18n.t('dash-vas-plantime')}</div>
                  <div className="choose-tag">
                    <div
                      onClick={() => this.setDays({ days: this.planDays })}
                      className={this.daysClassName(this.planDays)}>
                      {i18n.t('dash-vas-planalign')}
                      {this.hasDiscount(this.planDays)}
                    </div>
                    <div
                      onClick={() => this.setDays({ days: 30 })}
                      className={this.daysClassName(30)}>
                      30
                    </div>
                    <div
                      onClick={() => this.setDays({ days: 90 })}
                      className={this.daysClassName(90)}>
                      90
                    </div>
                    <div
                      onClick={() => this.setDays({ days: 180 })}
                      className={this.daysClassName(180)}>
                      180
                      {this.hasDiscount(180)}
                    </div>
                    <div
                      onClick={() => this.setDays({ days: 360 })}
                      className={this.daysClassName(360)}>
                      360
                      {this.hasDiscount(360)}
                    </div>
                  </div>
                </div>
                <div className="vas-price">
                  <div className="label">{i18n.t('dash-vas-orderprice')}</div>
                  <div className="num">{this.totalPrice(true)}</div>
                </div>
              </div>
            </div>
            <div className="product-info">
              <VasTips plan={this.state.plan}></VasTips>
              <div className="title">{i18n.t('dash-vas-orderintro')}</div>
              <div className="des">
                {this.state.plan ? (
                  this.state.plan.feature.split('\n').map((item, index) => (
                    <p key={`feature-${index}`}>{item}</p>
                  ))
                ) : (
                  <div className="loading-feature">Loading...</div>
                )}
              </div>
            </div>
            <div className="product-payment-method">
              <div className="title">{i18n.t('dash-vas-paymethod')}</div>
              <div className="payment-method">
                {this.state.plan ? (
                  this.state.plan.paidType.map(key => {
                    const method = PAY_METHODS[key] || PAY_METHODS.DEFAULT;
                    return (
                      <div
                        key={key}
                        onClick={() => this.changePayMethod(key)}
                        className={`item ${this.state.paymethod === key ? 'active' : ''}`}
                      >
                        <i className={method.icon} />
                        <span>{method.name}</span>
                      </div>
                    );
                  })
                ) : (
                  <div>Loading...</div>
                )}
              </div>
            </div>
            <If
              condition={
                this.state.plan &&
                this.state.plan.dayPrice * this.state.days <= 0
              }>
              <div className="product-payment-price">
                <div className="price">
                  <span>{i18n.t('dash-vas-bought')}</span>
                </div>
              </div>
            </If>
            <If
              condition={
                this.state.plan &&
                this.state.plan.dayPrice * this.state.days > 0 &&
                this.state.plan.canBuy
              }>
              <div className="product-payment-price">
                <div className="price">
                  <span>{i18n.t('dash-vas-total')}</span>
                  <div className="num">{this.totalPrice()}</div>
                  <div className="discount">{this.discountPrice()}</div>
                </div>
                <div className="payment-btn" onClick={this.startPay}>
                  {this.state.loading ? i18n.t('dash-vas-checking') : i18n.t('dash-vas-pay')}
                </div>
              </div>
            </If>
            <If condition={this.state.plan && !this.state.plan.canBuy}>
              <a className="product-payment-price" href="/buy">
                {this.state.plan ? this.state.plan.warnMessage : '-'}
              </a>
            </If>
          </div>
        </Card>
      </Page.Content>
    );
  }
}

export default VasIndex;
